const bodyScrollLock = import('./Lib/bodyScrollLock')
const noScroll = import('./Lib/no-scroll')

class MobileMenu {
    constructor(selector) {
        let menu = this
        this.$rootEl = document.documentElement
        this.$element = document.querySelector(selector)

        if (this.$element === null) {
            return
        }

        this.useSlidingMenu = true; //this.$element.getAttribute("data-use-sliding-menu");
        //console.debug("useSlidingMenu", this.useSlidingMenu);
        this.navActiveClass = 'is-active'
        //let naviInit = this.$element.dataset.initClass.split(" ")
        // this.naviInitClass = naviInit.filter(function (str) {
        //     return /\S/.test(str);
        // })
        
        this.naviInitClass = 'is-link';
        
        //this.naviInitClass
        this.clippedClass = 'is-clipped'
        this.$navbarBurgers = Array.prototype.slice.call(this.$element.querySelectorAll('.navbar-burger'), 0)
        this.$navbarMenu = this.$element; //this.$element.querySelector('#navbarMenu')
        this.$dropdownLinks = Array.prototype.slice.call(this.$element.querySelectorAll('.has-dropdown'), 0)
        this.$buttons = Array.prototype.slice.call(this.$element.querySelectorAll('.is-inverted'), 0)

        document.addEventListener('DOMContentLoaded', () => {
            if (typeof this.callback === 'function') {
                this.callback()
            }
        })

        document.addEventListener("click", function (event) {
            // console.log("click", event.target.closest(".has-children"));
            // debugger;
            if (event.target.closest(".has-children")!==null) {
                return
            }
           //console.log("click2", event.target.closest(".has-children"));
            menu.resetDropdowns()
        })

        // Slidable Menu
        this.$slidable_mobileMenu = this.$element.querySelector('.slideable-menu .menu');
        this.$slidable_subMenu = Array.prototype.slice.call(this.$element.querySelectorAll('.slideable-menu .slideable-submenu'), 0);
        this.$slidable_hasChildLink = Array.prototype.slice.call(this.$element.querySelectorAll('.has-children > a'), 0);

    }

    onReady(callback) {
        this.callback = callback
    }

    init() {
        (function (doc, proto) {
            try { // check if browser supports :scope natively
                doc.querySelector(':scope body');
            } catch (err) { // polyfill native methods if it doesn't
                ['querySelector', 'querySelectorAll'].forEach(function (method) {
                    var nativ = proto[method];
                    proto[method] = function (selectors) {
                        if (/(^|,)\s*:scope/.test(selectors)) { // only if selectors contains :scope
                            var id = this.id; // remember current element id
                            this.id = 'ID_' + Date.now(); // assign new unique id
                            selectors = selectors.replace(/((^|,)\s*):scope/g, '$1#' + this.id); // replace :scope with #ID
                            var result = doc[method](selectors);
                            this.id = id; // restore previous id
                            return result;
                        } else {
                            return nativ.call(this, selectors); // use native code for other selectors
                        }
                    }
                });
            }
        })(window.document, Element.prototype);

        // if (this.$navbarBurgers.length > 0) {
        //     this.$navbarBurgers.forEach(el => {
        //         el.addEventListener('click', () => {
        //             for (let index = 0; index < this.naviInitClass.length; ++index) {
        //                 this.$element.classList.toggle(this.naviInitClass[index])
        //             }
        //
        //             for (let index = 0; index < this.$buttons.length; ++index) {
        //                 this.$buttons[index].classList.toggle('is-inverted')
        //             }
        //             const target = el.dataset.target
        //
        //             const $target = document.getElementById(target)
        //             const $scrollable = $target.querySelector(".scroll-content");
        //
        //             //console.log("scroll-content", $scrollable, $target);
        //             this.$rootEl.classList.toggle(this.clippedClass);
        //             el.classList.toggle(this.navActiveClass)
        //             $target.classList.toggle(this.navActiveClass)
        //
        //             if ($target.classList.contains(this.navActiveClass)) {
        //                 bodyScrollLock.disableBodyScroll($scrollable)
        //                 noScroll.on();
        //             } else {
        //                 bodyScrollLock.enableBodyScroll($scrollable)
        //                 noScroll.off();
        //             }
        //
        //             if (this.useSlidingMenu) {
        //                 this.$slidable_mobileMenu.setAttribute("data-height", this.$slidable_mobileMenu.getBoundingClientRect().height);
        //             }
        //
        //         })
        //
        //     })
        //}


        //             const $target = document.getElementById(target)
        //             const $scrollable = $target.querySelector(".scroll-content");
        // if ($target.classList.contains(this.navActiveClass)) {
        //     bodyScrollLock.disableBodyScroll($scrollable)
        //     noScroll.on();
        // } else {
        //     bodyScrollLock.enableBodyScroll($scrollable)
        //     noScroll.off();
        // }

        // if (this.useSlidingMenu) {
        //     console.log("test", this.$slidable_mobileMenu);
        //     this.$slidable_mobileMenu.setAttribute("data-height", this.$slidable_mobileMenu.getBoundingClientRect().height);
        // }

        if (this.$dropdownLinks.length > 0) {
            this.$dropdownLinks.forEach(el => {
                el.addEventListener('click', (event) => {

                    if (event.target.classList.contains('navbar-link')) {
                        event.preventDefault()
                        for (var j = 0; j < this.$dropdownLinks.length; j++) {
                            if (el.id !== this.$dropdownLinks[j].id) {
                                this.$dropdownLinks[j].classList.remove(this.navActiveClass)
                            }
                        }
                        el.classList.toggle(this.navActiveClass)
                    }
                })
            })
        }


        // window.addEventListener('resize', () => {
        //     this.resetNavs()
        // })

        // Slidable menu

        
        if (this.useSlidingMenu && this.$slidable_subMenu.length > 0) {
            this.$slidable_subMenu.forEach(el => {
                
                const titleElement = el.parentElement.querySelector(".navbar-link");
                if(titleElement!==null) {
                    const backBtnText = titleElement.innerHTML;
                    el.insertAdjacentHTML("afterbegin", '<li class="back-btn"><a class="navbar-link arrow-left" href="#">' + backBtnText + '</a></li>');
                }
            });

            const backBtns = Array.prototype.slice.call(this.$navbarMenu.querySelectorAll('.slideable-menu .slideable-submenu .back-btn'), 0);

            backBtns.forEach(el => {
                el.addEventListener("click", (e) => {
                    const self = el;
                    const parent = self.parentNode;
                    const siblingParent = self.parentNode.parentNode.parentNode;
                    const menu = this.$navbarMenu.querySelector(".slideable-menu .menu");
                    
                    const menuInitHeight = menu.getAttribute("data-height");
                    
                    parent.classList.remove("in-view");
                    siblingParent.classList.remove("off-view");

                    const siblingParentClass = siblingParent.getAttribute("class");

                    if (siblingParentClass === "menu") {
                        //menu.style.height = menu.getBoundingClientRect().height + "px";
                        menu.style.height = menuInitHeight + "px";
                        //menu.style.height = siblingParent.getBoundingClientRect().height + "px";
                    } else {
                        menu.style.height = siblingParent.getBoundingClientRect().height + "px";
                    }

                    e.preventDefault();
                });
            });

            
            this.$slidable_hasChildLink.forEach(el => {
                const href = el.getAttribute("href");
                
                
                //
                // if (!(href === '' || href==='#')) {
                //     return;
                // }

                
                el.addEventListener("click", (e) => {
                    const self = el;
                    const parent = self.parentNode.parentNode; //.parentNode;
                    const menuParents = this.getParents(self, ".menu")
                    const menu = menuParents[menuParents.length - 1];
                    
                    const menuInitHeight = menu.getAttribute("data-height");
                    if(!menuInitHeight) {
                        menu.setAttribute("data-height", menu.getBoundingClientRect().height);
                    }
                    
                    parent.classList.add("off-view");

                    //const subMenu = self.parentNode.parentNode.querySelector(".slideable-submenu");
                    const subMenu = self.parentNode.querySelector(".slideable-submenu");
                    subMenu.classList.add("in-view");

                    //console.log("self.parentNode", self.parentNode);
                    //const slideableSubMenu = self.parentNode.parentNode.querySelector(":scope > .slideable-submenu")
                    const slideableSubMenu = self.parentNode.querySelector(":scope > .slideable-submenu")
                 
                    menu.style.height = slideableSubMenu.getBoundingClientRect().height + "px";

                    e.preventDefault();
                    return false;
                });
            });

        }
    }

    resetDropdowns() {
    //    
        
         //console.log("resetDropdowns", this.$slidable_mobileMenu);
         this.$slidable_mobileMenu.classList.remove("off-view");
         this.$slidable_mobileMenu.style.height = "auto";
        
        for (var j = 0; j < this.$slidable_subMenu.length; j++) {
            this.$slidable_subMenu[j].classList.remove("in-view");
        }
    }

    resetNavs() {
        for (var i = 0; i < this.$navbarBurgers.length; i++) {
            this.$navbarBurgers[i].classList.remove(this.navActiveClass)
        }

        this.$navbarMenu.classList.remove(this.navActiveClass)
        this.$rootEl.classList.remove(this.clippedClass);

        for (let index = 0; index < this.naviInitClass.length; ++index) {
            this.$element.classList.add(this.naviInitClass[index])
        }

        for (let index = 0; index < this.$buttons.length; ++index) {
            this.$buttons[index].classList.add('is-inverted')
        }

        this.resetDropdowns()

    }

    getParents(el, parentSelector, elIndex, parentIndex) {
        if (parentSelector === undefined) {
            parentSelector = document;
        }

        function ifStringUseQS(selector, index) {

            if (!index) index = 0;

            if (Object.prototype.toString.call(selector).toLowerCase().indexOf('string') > -1) { // Is it a string?

                /**
                 *
                 * If the selector can potentially refer to more than one element,
                 * then entering an index will allow you grab that specific element.
                 *
                 */

                return document.querySelectorAll(selector)[index];

            } else {

                return selector; // If it's not a string, it'll just be reassigned unto itself.

            }

        }

        el = ifStringUseQS(el, elIndex);

        parentSelector = ifStringUseQS(parentSelector, parentIndex);


        if (!el) return; // If el is undefined, hit the brakes.


        const parents = [];
        let p = el.parentNode;
        while (p !== parentSelector) {
            parents.push(p);
            p = p.parentNode;
        }
        parents.push(parentSelector);
        return parents;
    }
}


export default MobileMenu
  